import React, { ReactElement } from 'react'
import { Box, Flex, Text } from 'theme-ui'
import { Svg } from 'ui'
import FactoryIcon from 'images/organization/homepage/sections/industries/factory.svg'
import BlurIcon from 'images/organization/homepage/sections/industries/blur.svg'
import LogoBgIcon from 'images/organization/homepage/sections/industries/logo-bg.svg'
import StarsWrapper, { bigStarStyles } from 'components/Organization/HomePage/StarsWrapper'
import IndustriesContent from './IndustriesContent'

export default function Industries(): ReactElement {
  return (
    <Flex
      data-testid="industries-section"
      className="ios-scrolling-glitches-fix"
      sx={{
        position: 'relative',
        width: '100%',
        justifyContent: 'center',
        pt: ['6.4rem', '2rem', '10rem'],
        px: ['1.6rem', 0],
        backgroundColor: 'blue800',
      }}
    >
      <Flex
        className="ios-scrolling-glitches-fix"
        sx={{
          position: 'absolute',
          width: '100%',
          height: '32rem',
          top: '14.8rem',
          background: 'aquamarine8',
          filter: 'blur(150px)',
        }}
      />
      <Svg
        svg={LogoBgIcon}
        sx={{
          visibility: ['hidden', 'hidden', 'visible'],
          position: 'absolute',
          top: '-30rem',
          left: 0,
        }}
        descriptiveText="Decorative logo background for industries section"
      />
      <Flex
        sx={{
          width: '100%',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          zIndex: 'zIndex5',
        }}
      >
        <StarsWrapper
          starsSx={[
            {
              top: '0',
              left: '5rem',
            },
            {
              top: '5rem',
              left: '-14rem',
            },
            {
              top: '20rem',
              right: '-20rem',
              ...bigStarStyles,
            },
          ]}
        >
          <Flex sx={{ flexDirection: 'column', alignItems: 'center', height: 'fit-content' }}>
            <Flex
              sx={{
                position: 'relative',
                width: '8rem',
                height: '8rem',
                py: 0,
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Flex
                sx={{
                  position: 'absolute',
                  top: 0,
                  borderRadius: '50%',
                  width: '7.8rem',
                  height: '7.8rem',
                  justifyContent: 'center',
                  alignItems: 'center',
                  background:
                    'linear-gradient(180deg, rgba(102, 255, 251, 0.1) 0%, rgba(102, 255, 251, 0.00) 100%)',
                }}
              />
              <svg
                width="80"
                height="80"
                style={{ position: 'absolute', top: 0, transform: 'rotate(30deg)' }}
              >
                <linearGradient id="linearColors" x1="0" y1="0" x2="1" y2="1">
                  <stop offset="0%" stopColor="rgba(102, 255, 251, 0.20)"></stop>
                  <stop offset="100%" stopColor="rgba(102, 255, 251, 0)"></stop>
                </linearGradient>
                <circle
                  r="38"
                  cx="40"
                  cy="39"
                  className="external-circle"
                  strokeWidth="1"
                  fill="none"
                  stroke="url(#linearColors)"
                ></circle>
              </svg>
              <Svg
                svg={BlurIcon}
                sx={{ position: 'absolute', top: '-50%' }}
                descriptiveText="Blur effect for industries icon"
              />
              <Svg
                svg={FactoryIcon}
                sx={{
                  display: 'flex',
                  width: '4.8rem',
                  height: '4.8rem',
                }}
                descriptiveText="Factory icon representing industries section"
              />
            </Flex>
            <Text
              as="h2"
              sx={{
                color: 'aliceBlue',
                fontSize: ['2.8rem', '2.8rem', '4rem'],
                fontWeight: 600,
                mt: '1.6rem',
              }}
            >
              Industries
            </Text>
            <Text
              sx={{
                position: 'relative',
                width: ['100%', '35.8rem', '48rem'],
                color: 'lightSteelBlue',
                fontSize: ['1.5rem', '1.5rem', '1.6rem'],
                lineHeight: ['138%', '138%', '140%'],
                mt: ['0.8rem', '0.8rem', 0],
              }}
            >
              Control D can be used on a network of any size, and give you advanced capabilities in
              an interface that doesn&apos;t require reading a 900 page manual, or being
              “certified”.
              <Box
                sx={{
                  display: ['block', 'block', 'none'],
                  position: 'absolute',
                  top: '-5rem',
                  maxWidth: '39rem',
                  width: '100%',
                  height: '10rem',
                  backgroundColor: 'rgba(102, 255, 255, 0.15)',
                  filter: 'blur(75px)',
                }}
              />
            </Text>
          </Flex>
        </StarsWrapper>

        <IndustriesContent />
      </Flex>
    </Flex>
  )
}
